import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './i18n';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { TripppMapPage } from './pages/TripppMapPage';
import { TripppSparkPage } from './pages/TripppSparkPage';
import { TripppOpsPage } from './pages/TripppOpsPage';
import { UseCaseDMOPage } from './pages/UseCaseDMOPage';
import { UseCaseDMCPage } from './pages/UseCaseDMCPage';
import { UseCaseHotelsPage } from './pages/UseCaseHotelsPage';
import { UseCaseRealEstatePage } from './pages/UseCaseRealEstatePage';
import { PricingPage } from './pages/PricingPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-[#050505] text-white selection:bg-[#FF3CAC] selection:text-white" data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Navbar data-id="element-3" />
        <main data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/products/map" element={<TripppMapPage data-id="element-9" />} data-id="element-8" />
            <Route path="/products/spark" element={<TripppSparkPage data-id="element-11" />} data-id="element-10" />
            <Route path="/products/ops" element={<TripppOpsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/use-cases/dmo" element={<UseCaseDMOPage data-id="element-15" />} data-id="element-14" />
            <Route path="/use-cases/dmc" element={<UseCaseDMCPage data-id="element-17" />} data-id="element-16" />
            <Route path="/use-cases/hotels" element={<UseCaseHotelsPage data-id="element-19" />} data-id="element-18" />
            <Route path="/use-cases/real-estate" element={<UseCaseRealEstatePage data-id="element-21" />} data-id="element-20" />
            <Route path="/pricing" element={<PricingPage data-id="element-23" />} data-id="element-22" />
            <Route path="/about" element={<AboutPage data-id="element-25" />} data-id="element-24" />
            <Route path="/contact" element={<ContactPage data-id="element-27" />} data-id="element-26" />
          </Routes>
        </main>
        <Footer data-id="element-28" />
      </div>
    </LanguageProvider>;
}